import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "global-unread-badge" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { mainStore } from '@/stores/mainStore';
import { useMensajesUnreadStore } from '@/stores/mensajesUnread';
import { IonApp, IonRouterOutlet, IonLoading, IonIcon } from '@ionic/vue';
import { mailOutline } from 'ionicons/icons';
import InstallAppBanner from '@/components/InstallAppBanner.vue';
import AvisoAppModal from '@/components/AvisoAppModal.vue';
import AppVersionOutdatedModal from '@/components/AppVersionOutdatedModal.vue';
import SupervisionBanner from '@/components/SupervisionBanner.vue';
import { useInstallAppBanner } from '@/composables/useInstallAppBanner';
import { useAvisoApp } from '@/composables/useAvisoApp';
import { configureNativeStatusBar, markNativeAndroidDom } from '@/composables/useNativeStatusBar';
import { setupIdleHomeRedirect } from '@/composables/useIdleHomeRedirect';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const mainStoreInstance = mainStore();
const { visible: showInstallBanner } = useInstallAppBanner();
const router = useRouter();
const route = useRoute();
const unreadStore = useMensajesUnreadStore();
const avisoApp = useAvisoApp();
const { count: unreadCount } = storeToRefs(unreadStore);

markNativeAndroidDom();

let stopIdleHomeRedirect: (() => void) | undefined;

const hasSupervisionBanner = ref(!!localStorage.getItem('supervision'));
const tokenPresent = ref(!!localStorage.getItem('token'));
const lastTokenPresent = ref(tokenPresent.value);

const showUnreadBubble = computed(
  () => tokenPresent.value && unreadCount.value > 0
);

/** Solo en rutas sin cabecera (p. ej. clase concreta): ahí no está GalidanciaHomeLogo */
const showGlobalUnreadBubble = computed(() => {
  if (!showUnreadBubble.value) return false;
  return /^\/tabs\/clases\/\d+$/.test(route.path || '');
});

const unreadBadgeText = computed(() => {
  const n = unreadCount.value;
  if (n > 99) return '99+';
  return String(n);
});

const goMensajes = () => {
  void router.push('/tabs/mensajes');
};

router.afterEach(() => {
  tokenPresent.value = !!localStorage.getItem('token');
  if (tokenPresent.value === lastTokenPresent.value) {
    return;
  }
  if (tokenPresent.value) {
    unreadStore.startPolling();
    avisoApp.startPolling();
  } else {
    unreadStore.resetAndStop();
    avisoApp.resetAndStop();
  }
  lastTokenPresent.value = tokenPresent.value;
});

onMounted(() => {
  void configureNativeStatusBar();
  stopIdleHomeRedirect = setupIdleHomeRedirect(router);
  if (localStorage.getItem('token')) {
    unreadStore.startPolling();
    avisoApp.startPolling();
  }
  lastTokenPresent.value = !!localStorage.getItem('token');
});

onUnmounted(() => {
  stopIdleHomeRedirect?.();
  stopIdleHomeRedirect = undefined;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), {
    class: _normalizeClass({ 'has-install-banner': _unref(showInstallBanner), 'has-supervision-banner': hasSupervisionBanner.value })
  }, {
    default: _withCtx(() => [
      _createVNode(SupervisionBanner),
      _createVNode(InstallAppBanner),
      _createVNode(AvisoAppModal),
      _createVNode(AppVersionOutdatedModal),
      _createVNode(_unref(IonLoading), {
        "is-open": _unref(mainStoreInstance).$state.loading.show,
        message: _unref(mainStoreInstance).$state.loading.message
      }, null, 8, ["is-open", "message"]),
      _createVNode(_unref(IonRouterOutlet)),
      _withDirectives(_createElementVNode("button", {
        type: "button",
        class: "global-unread-bubble",
        "aria-label": "Mensajes sin leer",
        onClick: goMensajes
      }, [
        _createVNode(_unref(IonIcon), { icon: _unref(mailOutline) }, null, 8, ["icon"]),
        _createElementVNode("span", _hoisted_1, _toDisplayString(unreadBadgeText.value), 1)
      ], 512), [
        [_vShow, showGlobalUnreadBubble.value]
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})